import { Box, Button, Container, Divider, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import AnimationPage from '../AnimationPage';
import BreadCrumb from '../../components/bread-crumb';

export default function SectionFour({ section, setSection }) {
  return (
    <AnimationPage sx={{ backgroundColor: 'blue' }}>
      <Box
        sx={{
          height: '100vh',
          backgroundColor: '#fafbfc',
          pt: 6,
          pl: 7,
        }}>
        <img src="/images/logo/logoo.svg" alt="logo" />

        <Container maxWidth="lg" sx={{ mt: 13.5 }}>
          {/* <BreadCrumb section={section} crumbName4={'완료'} /> */}
          <Paper
            sx={{
              // color: theme.palette.info.main,
              boxShadow: '0px 0px 7px #0000001A',
              borderRadius: '10px',
              elevation: 3,
              py: 7,
              px: 7.5,
            }}>
            <Typography
              sx={{
                fontSize: '30px',
                lineHeight: '35.8px',
                fontWeight: 700,
                textAlign: 'center',
                mt: 11.5,
              }}>
              회원가입 신청 완료
            </Typography>

            <Typography sx={{ textAlign: 'center', mt: 10.5, fontWeight: 500, fontSize: '24px', lineHeight: '40px' }}>
              바디스위치를 이용하여 주심 감사드립니다!
              <br />
              관리자가 빠르게 확인 후<br /> 승인해 드리도록 하겠습니다.
            </Typography>

            <Divider sx={{ border: '1px solid #E7E7E7', mt: 12.25, mb: 3 }} />

            <Stack sx={{ flexDirection: 'row', justifyContent: 'center' }}>
              <Button href="/login" variant="contained" color="primary" sx={{ borderRadius: '5px', minWidth: 183 }}>
                확인
              </Button>
            </Stack>
          </Paper>
        </Container>
      </Box>
    </AnimationPage>
  );
}
